/**
 * @generated SignedSource<<d664074b3da9c73714a8b50ea1d57906>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RegisterInstrumentWarrantyCommencementDateQuery$variables = {
  instrumentId: string;
};
export type RegisterInstrumentWarrantyCommencementDateQuery$data = {
  readonly warrantyCommencementDate: any | null | undefined;
};
export type RegisterInstrumentWarrantyCommencementDateQuery = {
  response: RegisterInstrumentWarrantyCommencementDateQuery$data;
  variables: RegisterInstrumentWarrantyCommencementDateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "instrumentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "instrumentId",
        "variableName": "instrumentId"
      }
    ],
    "kind": "ScalarField",
    "name": "warrantyCommencementDate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterInstrumentWarrantyCommencementDateQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegisterInstrumentWarrantyCommencementDateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3fbd700a2dfaaf35f522538d920473f",
    "id": null,
    "metadata": {},
    "name": "RegisterInstrumentWarrantyCommencementDateQuery",
    "operationKind": "query",
    "text": "query RegisterInstrumentWarrantyCommencementDateQuery(\n  $instrumentId: String!\n) {\n  warrantyCommencementDate(instrumentId: $instrumentId)\n}\n"
  }
};
})();

(node as any).hash = "97d6b8e55f2d5e0ba31d4e05ff4b8b70";

export default node;
